import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../Assets/Logo/Myrtle Logo 150PX.png";
import {
  Navbar as BootstrapNavbar,
  Nav,
  Button,
  Container,
  NavDropdown,
  LinkContainer,
} from "react-bootstrap";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const isActive = (path) => window.location.pathname === path;

  // Change background on scroll
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <BootstrapNavbar
      expanded={expanded}
      expand="lg"
      className={`navbar navbar-light ${scrolled ? "scrolled" : ""}`}
      fixed="top"
    >
      <Container>
        <BootstrapNavbar.Brand href="/">
          <img src={logo} alt="Logo" className="navbar-logo" />
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />
        <BootstrapNavbar.Collapse id="navbar-nav">
          <Nav className="mx-auto">
            {/* <Nav.Link
              href="/services"
              className={`nav-link ${isActive("/services") ? "active" : ""}`}
            >
              Services
            </Nav.Link> */}
            <li className="nav-item dropdown">
              <a
                className={`nav-link dropdown-toggle ${
                  isActive("/services") ? "active" : ""
                }`}
                href="#"
                id="servicesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Services
              </a>
              <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                <li>
                  <a className="dropdown-item" href="/services">
                    Provider Service
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="/services/payers">
                    Payer Service
                  </a>
                </li>
              </ul>
            </li>

            <Nav.Link
              href="/whoandwhymyrtle"
              className={`nav-link ${
                isActive("/whoandwhymyrtle") ? "active" : ""
              }`}
            >
              Who & Why Myrtle
            </Nav.Link>
            <Nav.Link
              href="/broadcasts"
              className={`nav-link ${isActive("/broadcasts") ? "active" : ""}`}
            >
              Broadcasts
            </Nav.Link>
          </Nav>
          <div className="d-none d-lg-block">
            <Button
              variant="outline-light"
              href="/contactus"
              className="navbutton"
            >
              Let's Connect
            </Button>
          </div>
          <div className="d-lg-none mt-3">
            <Nav.Link href="/contactus" className="nav-link">
              Let's Connect
            </Nav.Link>
          </div>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
